export default {
  buttons: {
    create: 'Criar',
    update: 'Atualizar',
    cancel: 'Cancelar',
  },
  fields: {
    title: {
      label: 'Título',
      placeholder: 'Introduzir título',
    },
    description: {
      label: 'Descrição',
      placeholder: 'Introduzir descrição',
    },
    button_text: {
      label: 'Texto do Botão',
      placeholder: 'Introduzir texto do botão',
    },
    button_url: {
      label: 'URL do Botão',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Imagem',
    },
  },
  title: 'Criar publicação',
};
